import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { setupScrollAnimations } from '../utils/scrollAnimations';
import './style.css';

// Import contracting image
import ContractingImage from './images/contracting/Contracting.jpg';

const Contracting = () => {
  const { t } = useTranslation();
  
  useEffect(() => {
    setupScrollAnimations();
  }, []);
  
  return (
    <motion.main
      className="page-content"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.5 }}
    >
        <div className="service-content">
          {/* Hero Section with Image */}
          <div className="service-hero animate-on-scroll">
            <div className="service-hero-content">
              <h1>{t('services.contracting.title')}</h1>
              <p className="service-hero-subtitle">
                {t('services.contracting.subtitle')}
              </p>
            </div>
            <div className="service-hero-image">
              <img src={ContractingImage} alt="Contracting Services" className="hero-image" />
            </div>
          </div>
          
          {/* Services Grid with Images */}
          <div className="service-sections">
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">🏠</div>
                <h3>{t('services.contracting.residential.title')}</h3>
                <p>
                  {t('services.contracting.residential.description')}
                </p>
              </div>
              <div className="service-section-image">
                <div className="image-placeholder">
                  <span>Residential</span>
                </div>
              </div>
            </div>
            
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">🏢</div>
                <h3>{t('services.contracting.commercial.title')}</h3>
                <p>
                  {t('services.contracting.commercial.description')}
                </p>
              </div>
              <div className="service-section-image">
                <div className="image-placeholder">
                  <span>Commercial</span>
                </div>
              </div>
            </div>
            
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">🏭</div>
                <h3>{t('services.contracting.industrial.title')}</h3>
                <p>
                  {t('services.contracting.industrial.description')}
                </p>
              </div>
              <div className="service-section-image">
                <div className="image-placeholder">
                  <span>Industrial</span>
                </div>
              </div>
            </div>
            
            <div className="service-section">
              <div className="service-section-content animate-on-scroll">
                <div className="service-icon">📋</div>
                <h3>{t('services.contracting.management.title')}</h3>
                <p>
                  {t('services.contracting.management.description')}
                </p>
              </div>
              <div className="service-section-image">
                <div className="image-placeholder">
                  <span>Management</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Capabilities Section */}
          <div className="service-features">
            <h3>{t('services.contracting.capabilities.title')}</h3>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">🎨</div>
                <div className="feature-text">{t('services.contracting.capabilities.item1')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🔨</div>
                <div className="feature-text">{t('services.contracting.capabilities.item2')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🏗️</div>
                <div className="feature-text">{t('services.contracting.capabilities.item3')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⚡</div>
                <div className="feature-text">{t('services.contracting.capabilities.item4')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🎯</div>
                <div className="feature-text">{t('services.contracting.capabilities.item5')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌳</div>
                <div className="feature-text">{t('services.contracting.capabilities.item6')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📄</div>
                <div className="feature-text">{t('services.contracting.capabilities.item7')}</div>
              </div>
            </div>
          </div>
          
          {/* Why Choose Us Section */}
          <div className="service-features">
            <h3>{t('services.contracting.whyChoose.title')}</h3>
            <div className="features-grid">
              <div className="feature-item">
                <div className="feature-icon">📜</div>
                <div className="feature-text">{t('services.contracting.whyChoose.item1')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">👷</div>
                <div className="feature-text">{t('services.contracting.whyChoose.item2')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">⭐</div>
                <div className="feature-text">{t('services.contracting.whyChoose.item3')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💰</div>
                <div className="feature-text">{t('services.contracting.whyChoose.item4')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🛡️</div>
                <div className="feature-text">{t('services.contracting.whyChoose.item5')}</div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌱</div>
                <div className="feature-text">{t('services.contracting.whyChoose.item6')}</div>
              </div>
            </div>
          </div>
          
          {/* Gallery Section */}
          <div className="service-gallery">
            <h3>{t('services.contracting.gallery.title')}</h3>
            <div className="gallery-grid">
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 1</span>
                </div>
              </div>
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 2</span>
                </div>
              </div>
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 3</span>
                </div>
              </div>
              <div className="gallery-item">
                <div className="image-placeholder">
                  <span>Project 4</span>
                </div>
              </div>
            </div>
          </div>
          
          {/* Contact Us Section */}
          <div className="service-contact-section">
            <div className="service-contact-content">
              <h3>{t('services.contracting.contact.title')}</h3>
              <p>{t('services.contracting.contact.description')}</p>
              <Link to="/contact?service=contracting" className="service-contact-btn btn-animated hover-lift">
                {t('services.contracting.contact.button')}
              </Link>
            </div>
          </div>
      </div>
    </motion.main>
  );
};

export default Contracting;
